import React, { createContext, useContext, useState, useEffect } from "react";

const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};

export const SidebarProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [inSubmenu, setInSubmenu] = useState(false);

  // 📱 Auto-collapse on mobile (but not when in submenu)
  useEffect(() => {
    const handleResize = () => {
      if (!inSubmenu) {
        // On mobile, start collapsed; on desktop, start expanded
        setIsOpen(window.innerWidth >= 768);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [inSubmenu]);

  const toggle = () => {
    // Don't allow collapse when in submenu
    if (inSubmenu) return;
    setIsOpen(!isOpen);
  };

  const value = {
    isOpen,
    toggle,
    setIsOpen,
    inSubmenu,
    setInSubmenu,
  };

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};
